import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadCrmAuthInfo } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export const getCrmIntegrationAuthInfo = async (
  integrationId: string
): Promise<ReadCrmAuthInfo> => {
  return await tinctApi.crmIntegrations.getCrmIntegrationAuthInfo(integrationId);
};

export const useGetCrmIntegrationAuthInfo = (
  integrationId: string | undefined,
  options?: Omit<
    UseQueryOptions<ReadCrmAuthInfo, ApiError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery({
    queryKey: ['crm-integration-auth-info', integrationId],
    queryFn: () => getCrmIntegrationAuthInfo(integrationId as string),
    enabled: !!integrationId,
    ...options,
  });
